const firebaseConfig = {
  apiKey: "AIzaSyAsQtjonxBxLOzJkNNY8izGk48GLQPIPb4",
  authDomain: "trust-care-123.firebaseapp.com",
  projectId: "trust-care-123",
  storageBucket: "trust-care-123.appspot.com",
  messagingSenderId: "1053842460223",
  appId: "1:1053842460223:web:a009afd877057dc8c5328a"
};

export default firebaseConfig;